// Property type factories used to build appearance editors
import { StrokeType } from "../PropertyTypes";

// Alertas (Alerts) category - price alert tools
const alertasRegistry = {
  displayName: "Alertas",
  interactives: {
    // TODO: Re-enable when price crossing detection is fixed
    // stopLine: {
    //     displayName: 'Linha Stop',
    //     key: 'stopLine',
    //     icon: 'Alert_Bell',
    //     propName: 'stopLines',
    //     component: 'StopLine',
    //     defaultOptionsForAppearance: [
    //         StrokeType({ name: 'stroke', displayName: 'Cor da Linha', defaultValue: { color: '#E91E63', dash: 'ShortDash2', width: 2, opacity: 1 } }),
    //     ]
    // },
  },
};

export default alertasRegistry;
